import ShortAnswerFormFieldComponent from "./fields/ShortAnswerFormFieldComponent";
import LongAnswerFormFieldComponent from "./fields/LongAnswerFormFieldComponent";
import DateFormFieldComponent from "./fields/DateFormFieldComponent";
import DataConsentFormFieldComponent from "./fields/DataConsentFormFieldComponent";
import ReCaptcha2FormFieldComponent from "./fields/ReCaptcha2FormFieldComponent";
import DropdownFormFieldComponent from "./fields/DropdownFormFieldComponent";
import SingleChoiceFormFieldComponent from "./fields/SingleChoiceFormFieldComponent";
import MultipleChoiceFormFieldComponent from "./fields/MultipleChoiceFormFieldComponent";
import ChildInformationFormFieldComponent from "./fields/ChildInformationFormFieldComponent";

import RequiredFieldValidator from "./validators/RequiredFieldValidator";
import RegexFieldValidator from "./validators/RegexFieldValidator";
import BriteVerifyFieldValidator from "./validators/BriteVerifyFieldValidator";
import ChildInformationFieldValidator from "./validators/ChildInformationFieldValidator";

export default class FormFieldHelper {

    static getFieldComponent(el) {
        const { umbFieldType } = el.dataset;

        switch (umbFieldType) {
            case 'shortAnswer':
                return new ShortAnswerFormFieldComponent(el);
            case 'longAnswer':
                return new LongAnswerFormFieldComponent(el);
            case 'date':
                return new DateFormFieldComponent(el);
            case 'dataConsent':
                return new DataConsentFormFieldComponent(el);
            case 'dropdown':
                return new DropdownFormFieldComponent(el);
            case 'recaptcha2':
                return new ReCaptcha2FormFieldComponent(el);
            case 'singleChoice':
                return new SingleChoiceFormFieldComponent(el);
            case 'multipleChoice':
                return new MultipleChoiceFormFieldComponent(el);
            case 'childInformation':
                return new ChildInformationFormFieldComponent(el);
            default:
                return undefined;
        }
    }

    static getRequiredFieldValidator(field) {
        if (!field) {
            return undefined;
        }

        const { valRequired } = field.dataset;
        if (!valRequired) {
            return undefined;
        }

        return new RequiredFieldValidator(valRequired);
    }

    static getBriteVerifyFieldValidator(field) {
        if (!field) {
            return undefined;
        }

        if (field.type !== 'email') {
            return undefined;
        }

        return new BriteVerifyFieldValidator();
    }

    static getChildInformationFieldValidator(field) {
        if (!field) {
            return undefined;
        }

        return new ChildInformationFieldValidator();
    }

    static getRegexFieldValidator(field) {
        if (!field) {
            return undefined;
        }

        const { valRegexPattern, valRegex } = field.dataset;

        if (!valRegex && !valRegexPattern) {
            return undefined;
        }

        return new RegexFieldValidator(valRegex, valRegexPattern);
    }
}